export default class InactivityManager {
	
	constructor() {
		this.lastActivityTime = Date.now();
		this.EVENTS = ['load', 'click', 'mousedown', 'mousemove', 'keydown', 'scroll', 'ontouchmove', 'touchstart'];
	}
	
	calcActivity() 
    {
		this.EVENTS.forEach(function (name) {
		  document.addEventListener(name, this.resetTimer, true);
		}, this);
	}

	getInactivityTime()
	{
		return Date.now() - this.lastActivityTime;
	}

	resetTimer() 
	{
		window.inactivityManager.lastActivityTime = Date.now();
	}
}
